var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center-container px-0"},[_c('div',{staticClass:"priv-connection-container"},[[_c('div',{attrs:{"id":"terminal-content"}})]],2)])}
var staticRenderFns = []

export { render, staticRenderFns }